export default __webpack_public_path__ + "static/media/menu.28b5ab0a.svg";